var _clipPath;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCreateProjectDisabled = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  xmlSpace: "preserve",
  style: {
    fillRule: "evenodd",
    clipRule: "evenodd"
  },
  viewBox: "0 0 33 28"
}, props), /*#__PURE__*/React.createElement("g", {
  transform: "matrix(.42308 0 0 .4375 -2.538 -3.5)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M6 8h78v64H6z",
  style: {
    fill: "none"
  }
}), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
  id: "create_project_disabled_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  d: "M6 8h78v64H6z"
}))), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#create_project_disabled_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M39 47h8v4h-8zM53 47v4h8v-4h-8ZM57.277 40.494 51 40.5v-3.76h5.24V31H43.755v5.74H49v3.754h-7v5.248h2v-3.156h6.523l5.477-.01v3.166h2v-5.258l-.723.01Z",
  style: {
    fill: "currentColor",
    fillRule: "nonzero"
  },
  transform: "matrix(2.36364 0 0 2.28571 -83.818 -46.857)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M53 34a8 8 0 1 0 16 0 8 8 0 1 0-16 0Zm7-4h2v3h3v2h-3v3h-2v-3h-3v-2h3Z",
  style: {
    fill: "currentColor",
    fillRule: "evenodd"
  },
  transform: "matrix(2.36364 0 0 2.28571 -83.818 -46.857)"
}))));
export default SvgCreateProjectDisabled;